/* global.css trims every text node to its cap-height/alphabetic-baseline box (matching Figma),
 * but the card is a fixed-size `overflow-hidden` box, so a trimmed line box can clip glyphs
 * (e.g. the descenders in "Select currency"/"Select plan") against that boundary.
 *
 * Deliberately left OUTSIDE `@layer components`: this file loads two different ways depending
 * on the page — inlined into `<head>` on the homepage, linked via `<link rel="stylesheet">` on
 * /send-money-home — and only the inlined path reliably lands the `components` layer above
 * global.css's `base` layer; on the linked path `base` still won and this rule was a no-op
 * (confirmed via computed `text-box-trim` differing between the two pages). An unlayered rule
 * always outranks a layered one regardless of layer order or specificity, so it works on both. */
.calc-card
  :where(
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a,
    span,
    li,
    label,
    figcaption,
    output,
    blockquote,
    dt,
    dd,
    button
  ) {
  text-box-trim: none;
}

@layer components {
  /* `transform: scale()` + `border-radius`, not `clip-path` — matches the hero balance card's
   * `hero-card-reveal` recipe (see hero.css). clip-path forces the browser to recompute and
   * repaint the clip region every frame; a scale transform is compositor-only and stays smooth
   * even while the hero image's own load animation is running concurrently. */
  .calc-card {
    animation: calc-card-grow var(--calc-grow-ms, 520ms)
      var(--ease-out-strong, cubic-bezier(0.16, 1, 0.3, 1)) both;
  }

  @keyframes calc-card-grow {
    from {
      /* 40x40 circle centred in the 360x508 card, same starting size as before. */
      transform: scale(0.1111, 0.0787);
      border-radius: 50%;
    }
    to {
      transform: scale(1);
      border-radius: 40px;
    }
  }

  .calc-card__body {
    opacity: 0;
    animation: calc-card-body-in var(--calc-body-ms, 220ms) ease-out var(--calc-body-delay, 520ms)
      both;
  }

  @keyframes calc-card-body-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .calc-card {
    transform: none;
    animation: none;
  }

  .calc-card__body {
    opacity: 1;
    animation: none;
  }
}
